"use client";

import {
    BasePLogo,
    BasePP,
    BipolarBerlin,
    BipolarBerlinShort,
    Digdis,
    FinancialEuropeans,
    Hashrate,
    HashrateShort,
    Logo1SP,
    Logo1SPshort,
    MarsWalk,
    MarsWalkShort,
    NewFluence,
    SongPush,
    TalentirLogo,
    TalentirT,
    Vidsum,
    VidsumShort,
} from "@/components/theme/custom-svgs";
import { useSubdomainName } from "@/hooks/use-subdomain";

export function Logo({ variant = "regular", className }: { variant?: "regular" | "square"; className?: string }) {
    const { subDomain } = useSubdomainName();

    if (variant === "square") {
        if (subDomain === "basep") {
            return <BasePP className={className} />;
        }

        if (subDomain === "1sp") {
            return <Logo1SPshort className={className} />;
        }

        if (subDomain === "vidsum") {
            return <VidsumShort className={className} />;
        }

        if (subDomain === "hashrate") {
            return <HashrateShort className={className} />;
        }

        if (subDomain === "marswalk") {
            return <MarsWalkShort className={className} />;
            // return <div>a</div>;
        }

        if (subDomain === "bipolar") {
            return <BipolarBerlinShort className={className} />;
        }

        if (subDomain === "fe") {
            return <FinancialEuropeans className={className} />;
        }

        return <TalentirT className={className} />;
    }

    if (subDomain === "basep") {
        return <BasePLogo className={className} />;
    }

    if (subDomain === "1sp") {
        return <Logo1SP className={className} />;
    }

    if (subDomain === "vidsum") {
        return <Vidsum className={className} />;
    }

    if (subDomain === "digdis") {
        return <Digdis className={className} />;
    }

    if (subDomain === "newfluence") {
        return <NewFluence className={className} />;
    }

    if (subDomain === "songpush") {
        return <SongPush className={className} />;
    }

    if (subDomain === "hashrate") {
        return <Hashrate className={className} />;
    }

    if (subDomain === "marswalk") {
        return <MarsWalk className={className} />;
    }

    if (subDomain === "bipolar") {
        return <BipolarBerlin className={className} />;
    }

    if (subDomain === "fe") {
        return <FinancialEuropeans className={className} />;
    }

    return <TalentirLogo className={className} />;
}
